// src/pages/Loads/Loads.jsx
import React, { useEffect, useState } from "react";
import FiltersPagination from "../../components/elements/FiltersPagination";
import DataTableElement from "../../components/elements/DataTableElement";
import {
  loadsResource,
  changeStatusLoad,
  getStatuses,
} from "../../helpers/configRoutes/backend_helper";
import { Columns } from "./Columns";
import CustomButton from "../../components/form/CustomButton";
import { useNavigate } from "react-router-dom";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import { useDispatch } from "react-redux";
import { reset_load, update_load } from "../../store/loads/action";
import LoadsMapView from "./LoadsMapView"; // 👈 nuevo componente
import EvidencesFilesModal from "./EvidencesFilesModal";
import usePlanUsage, { PLAN_FEATURES, usageBlockedMessage, usageLimitText } from "../../hooks/usePlanUsage";

const Loads = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [filters, setFilters] = useState({
    endDate: "",
    startDate: "",
    search: "",
    from: 0,
    to: 0,
    page: 1,
    truck: true,
  });

  const [tableLoad, setTableLoad] = useState({
    show: false,
    textLoad: "Loading loads...",
  });
  const [meta, setMeta] = useState({ total: 0, current_page: 0 });
  const [data, setData] = useState([]);
  const [statuses, setStatuses] = useState([]);

    const [modalConfirm, setModalConfirm] = useState({
    show: false,
    title: "Delete Load",
    loading: false,
    textLoad: "Processing",
  });
  const [modalFiles, setModalFiles] = useState({
    show: false,
    item: {},
    title: "Show files",
  });
  const [loadinStatus, setLoadinStatus] = useState(false);
  const [statusLoadingId, setStatusLoadingId] = useState(null);
  const { getFeature, canUse } = usePlanUsage();
  const loadsFeature = getFeature(PLAN_FEATURES.LOADS);
  const canAddLoad = canUse(PLAN_FEATURES.LOADS);

  // 👇 nuevo: modo de vista
  const [viewMode, setViewMode] = useState("table"); // 'table' | 'map'
  const [loadListMode, setLoadListMode] = useState("active"); // 'active' | 'completed'

  useEffect(() => {
    const getData = async () => {
      setTableLoad((prev) => ({ ...prev, show: true }));
      const requestFilters = {
        ...filters,
        ...(loadListMode === "completed"
          ? { only_completed: true, status_id: "" }
          : { hide_completed: true }),
      };
      const response = await loadsResource("get", { params: requestFilters });
      setData(response.loads || []);
      setMeta(response.meta || { total: 0, current_page: 0 });
      setTableLoad((prev) => ({ ...prev, show: false }));
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, loadListMode]);

  useEffect(() => {
    const getStatusesData = async () => {
      const response = await getStatuses({ params: { model: "Load" } });
      if (response?.status) {
        setStatuses(response.statuses || []);
      }
    };

    getStatusesData();
  }, []);

  const openModalAdd = (trailerTruckItem = {}) => {
    if (trailerTruckItem.id) {
      dispatch(update_load(trailerTruckItem));
      navigate(`/load/${trailerTruckItem.id}`);
      return true;
    }
    dispatch(reset_load());
  };

  const deleteTrailerTruck = async () => {
    setModalConfirm({ ...modalConfirm, loading: true });
    const response = await loadsResource(
      "del",
      {},
      modalConfirm.id
    );
    if (response.status) {
      setFilters({ ...filters });
    }
    setModalConfirm({
      ...modalConfirm,
      loading: false,
      show: false,
      id: null,
    });
  };

  const completeFinishLoad = async (load_id, status_id) => {
    setLoadinStatus(true);
    const response = await changeStatusLoad({
      load_id: load_id,
      status_id: status_id,
    });
    if (response.status) {
      setFilters({ ...filters });
    }
    setLoadinStatus(false);
  };

  const handleInlineStatusChange = async (loadId, statusId) => {
    if (!statusId) {
      return;
    }

    setStatusLoadingId(loadId);
    const response = await changeStatusLoad({
      load_id: loadId,
      status_id: Number(statusId),
    });

    if (response.status) {
      setData((prev) =>
        prev.map((item) => {
          if (item.id !== loadId) {
            return item;
          }

          const nextStatus = statuses.find(
            (status) => Number(status.id) === Number(statusId)
          );

          return {
            ...item,
            status_id: Number(statusId),
            status: nextStatus || item.status,
          };
        })
      );
    }

    setStatusLoadingId(null);
  };

  const cols = Columns(
    openModalAdd,
    setModalConfirm,
    modalConfirm,
    modalFiles,
    setModalFiles,
    completeFinishLoad,
    loadinStatus,
    statuses,
    handleInlineStatusChange,
    statusLoadingId
  );

  const handleLoadListModeChange = (mode) => {
    setLoadListMode(mode);
    setFilters((prev) => ({
      ...prev,
      page: 1,
      status_id: "",
    }));
  };

  return (
    <div className="min-h-screen bg-cs-surface">
      <div className="px-4 md:px-6 py-6 max-w-auto mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-cs-dark">Loads</h1>
            <p className="text-sm text-cs-muted mt-1">
              Manage loads, documents and related assignments with full
              tracking.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            {/* Toggle Table / Map */}
            <div className="inline-flex items-center bg-cs-bg border border-cs-border rounded-xl text-[11px] overflow-hidden">
              <button
                type="button"
                onClick={() => setViewMode("table")}
                className={`
                  px-3 py-1.5
                  ${viewMode === "table"
                    ? "bg-cs-primary text-white"
                    : "bg-cs-bg text-cs-muted"
                  }
                  text-xs font-medium transition-colors
                `}
              >
                Table view
              </button>
              <button
                type="button"
                onClick={() => setViewMode("map")}
                className={`
                  px-3 py-1.5 border-l border-cs-border
                  ${viewMode === "map"
                    ? "bg-cs-primary text-white"
                    : "bg-cs-bg text-cs-muted"
                  }
                  text-xs font-medium transition-colors
                `}
              >
                Map view
              </button>
            </div>

            <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
              Total loads:{" "}
              <span className="font-semibold text-cs-dark">
                {meta?.total ?? data.length}
              </span>
            </div>

            <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
              Plan loads:{" "}
              <span className="font-semibold text-cs-dark">
                {usageLimitText(loadsFeature, "loads")}
              </span>
            </div>

            <CustomButton
              onClick={() => canAddLoad && navigate("/loads-new")}
              disabled={!canAddLoad}
              title={!canAddLoad ? usageBlockedMessage(loadsFeature, "loads") : ""}
              className={`
                inline-flex items-center gap-2
                px-4 py-2.5
                rounded-xl
                ${canAddLoad ? "bg-cs-primary hover:bg-cs-primary-hover text-white shadow-md hover:shadow-lg" : "bg-gray-300 text-gray-600 cursor-not-allowed"}
                text-sm font-medium
                transition-all
              `}
            >
              <span className="material-symbols-outlined text-sm">{canAddLoad ? "add" : "lock"}</span>
              {canAddLoad ? "Add new load" : "Limit reached"}
            </CustomButton>
          </div>
        </div>

        {/* Tabla + filtros / Mapa + filtros */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-3">
          <div className="inline-flex items-center bg-cs-bg border border-cs-border rounded-xl text-[11px] overflow-hidden w-fit">
            <button
              type="button"
              onClick={() => handleLoadListModeChange("active")}
              className={`
                px-4 py-2
                ${loadListMode === "active"
                  ? "bg-cs-primary text-white"
                  : "bg-cs-bg text-cs-muted hover:bg-cs-bg-alt"
                }
                text-xs font-medium transition-colors
              `}
            >
              Active loads
            </button>
            <button
              type="button"
              onClick={() => handleLoadListModeChange("completed")}
              className={`
                px-4 py-2 border-l border-cs-border
                ${loadListMode === "completed"
                  ? "bg-cs-primary text-white"
                  : "bg-cs-bg text-cs-muted hover:bg-cs-bg-alt"
                }
                text-xs font-medium transition-colors
              `}
            >
              Completed loads
            </button>
          </div>

          <p className="text-xs text-cs-muted">
            {loadListMode === "active"
              ? "Completed loads are hidden from this dashboard. Use Completed loads to review them."
              : "Showing only completed loads."}
          </p>
        </div>

        <div
          className="
            bg-cs-bg border border-cs-border rounded-2xl
            shadow-sm px-2 py-2
          "
        >
          <FiltersPagination
            showFilters={true}
            filters={filters}
            setFilters={setFilters}
            meta={meta}
            statusModel="Load"
            lockedStatusId={loadListMode === "completed" ? 30 : null}
            excludedStatusIds={loadListMode === "active" ? [30] : []}
          >
            {viewMode === "table" ? (
              <DataTableElement
                columns={cols}
                items={data}
                tableLoad={tableLoad}
              />
            ) : (
              <LoadsMapView loads={data} loading={tableLoad.show} />
            )}
          </FiltersPagination>
        </div>

        <ConfirmDeleteModal
          modal={modalConfirm}
          setModal={setModalConfirm}
          action={deleteTrailerTruck}
        />

        {modalFiles.show && (
          <EvidencesFilesModal
            modal={modalFiles}
            setModal={setModalFiles}
            filters={filters}
            setFilters={setFilters}
          />
        )}
      </div>
    </div>
  );
};

export default Loads;
